import {
  getApiV1ThreeLetterCodeClientAdminsStressCheckSchedule,
  getGetApiV1ThreeLetterCodeClientAdminsStressCheckScheduleKey,
} from '@fukuri-admins/apis/client/gen/endpoints';
import type { GetApiV1ThreeLetterCodeClientAdminsStressCheckSchedule200 } from '@fukuri-admins/apis/client/gen/model';
import { useFetch } from '@fukuri-admins/hooks/common';

type Args = { threeLetterCode: string; enabled?: boolean };

export const useGetStressAssessmentSchedule = ({ threeLetterCode, enabled = true }: Args) => {
  const { data, mutate } = useFetch<GetApiV1ThreeLetterCodeClientAdminsStressCheckSchedule200>(
    enabled ? getGetApiV1ThreeLetterCodeClientAdminsStressCheckScheduleKey(threeLetterCode) : null,
    () => getApiV1ThreeLetterCodeClientAdminsStressCheckSchedule(threeLetterCode),
    { suspense: true }
  );
  return { data, mutate };
};
